/* eslint-disable no-constant-condition */
import React from 'react';
import { CartesianGrid, Label, Legend, Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { GraphWrapper } from './LineGraph.styled';
import { useTheme, Box } from '@mui/material';
import { chartsColors } from '../../../theme/colors';
import NoData from '../NoData';
import { CircleProgress } from '../../../components/common/CircleProgress';

type LineGraphChartType = {
  chartData: Array<Record<string, number | string>>;
  text: string;
  loading: boolean;
};
const LineGraphChart = (props: LineGraphChartType) => {
  const theme = useTheme();
  const { chartData, text, loading = false } = props;

  return (
    <GraphWrapper id={`chart-${text}`}>
      {chartData.length > 0 && !loading
        && (
          <ResponsiveContainer height={435} width="100%">
            <AreaChart
              margin={{
                top: 5,
                right: 5,
                left: 5,
                bottom: 5,
              }}
              data={chartData}
            >
              <XAxis
                minTickGap={30}
                dataKey="correctDate"
                type="category"
                allowDuplicatedCategory={false}
                style={{ fill: theme.palette.grey[500] }}
                height={35}
              >
                <Label
                  value="Date"
                  offset={-5}
                  position="insideBottom"
                  style={{ fill: theme.palette.grey[500] }}
                />
              </XAxis>
              <YAxis width={80} style={{ fill: theme.palette.grey[500] }}>
                <Label
                  value={`Number of ${text}`}
                  offset={5}
                  position="insideLeft"
                  angle={-90}
                  style={{ fill: theme.palette.grey[500] }}
                />
              </YAxis>
              <CartesianGrid vertical={false} />
              <Tooltip
                labelStyle={{ color: theme.palette.base.background }}
                contentStyle={{ backgroundColor: theme.palette.grey[900], color: theme.palette.base.background }}
              />
              <Legend
                iconType="circle"
                align="right"
                verticalAlign="top"
                iconSize={13}
              />
              {chartData[0] && Object.keys(chartData[0]).filter((key) => key !== 'correctDate').map((key, index) => {
                const color = chartsColors[index % 20];
                return (
                  <Area
                    key={key}
                    dot={false}
                    dataKey={key}
                    strokeWidth={2}
                    stroke={color}
                    fill={color}
                    type={'monotone'}
                  />
                );
              })}
            </AreaChart>
          </ResponsiveContainer>
        )}
      {chartData.length === 0 && !loading
        && (
          <NoData height="435px !important" />
        )}
      {loading && (
        <Box
          height={'435px !important'}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <CircleProgress />
        </Box>
      )}
    </GraphWrapper>
  );
};

export default LineGraphChart;
